import posthog from 'posthog-js';

export function trackJobViewed(job) {
    posthog.capture('job_viewed', {
        job_id: job.jobID,
        job_title: job.title,
        customerID: job.customerID,
        customerName: job.customerName,
    });
}


export function trackJobApplied(job) {
    posthog.capture('job_applied', {
        job_id: job.jobID,
        job_title: job.title,
        customerID: job.customerID,
        customerName: job.customerName,
    });
}


export function trackResumeDownloaded(resumeType) {
    posthog.capture("resume_downloaded", {
        resumeType: resumeType
    });
}


export function trackResumeUploaded(profileData) {
    posthog.capture("resume_uploaded", {
        ...profileData
    });
}

export function trackResumeCreated(profileData) {
    posthog.capture("resume_created", {
        ...profileData
    });
}


export function trackHomePageLoaded(profileData) {
    posthog.capture("homepage_loaded", {
        ...profileData
    });
}


export function trackAutoFilledFromResume(profileData) {
    posthog.capture("auto_filled_from_resume", {
        ...profileData
    });
}


export function trackFormSubmitted(formDetails) {
    posthog.capture("form_submitted", {
        ...formDetails
    });
}

export function trackSelfAssessPlayed(AssessDetails) {
    posthog.capture("self_asess_played", {
        ...AssessDetails
    });
}


export function trackAssessMarksViewed(assessDetails) {
    posthog.capture("result_viewed", {
        ...assessDetails
    });
}


export function trackGameStarted(gameDetails) {
    posthog.capture("game_started", {
        ...gameDetails
    });
}

export function trackGameEnded(gameDetails) {
    posthog.capture("game_completed", {
        ...gameDetails
    });
}

export function trackTimeSpent(pageDetails) {
    posthog.capture("page_time_spent", {
        ...pageDetails
    });
}


export function trackAccountDeleted(data) {
    posthog.capture("account_deleted", {
        ...data
    });
}


export function trackInstructorApplied(data) {
    posthog.capture("instructor_applied", {
        ...data
    });
}

export function trackPanelApplied(data) {
    posthog.capture("panelist_applied", {
        ...data
    });
}

export function trackQuizSubmitted(data) {
    posthog.capture("quiz_submitted", {
        ...data
    });
}

export function trackSurveyTaken(data) {
    posthog.capture("survey_taken", {
        ...data
    });
}

export function trackResumeClinicUsed(data) {
    posthog.capture("resumeclinic_report_used", {
        ...data
    });
}

export function trackResumeClinicReportDownloaded(data) {
    posthog.capture("resumeclinic_report_downloaded", {
        ...data
    });
}

export function trackResumeClinicReportViewed(data) {
    posthog.capture("resumeclinic_report_viewed", {
        ...data
    });
}